import React from 'react';
import { Check, Clock, AlertCircle } from 'lucide-react';
interface TimelineStep {
  label: string;
  status: 'completed' | 'active' | 'pending' | 'error';
  timestamp?: string;
}
interface StatusTimelineProps {
  steps: TimelineStep[];
}
export function StatusTimeline({
  steps
}: StatusTimelineProps) {
  const getIcon = (status: TimelineStep['status']) => {
    switch (status) {
      case 'completed':
        return <Check size={16} className="text-white" data-id="element-448" />;
      case 'active':
        return <Clock size={16} className="text-white" data-id="element-449" />;
      case 'error':
        return <AlertCircle size={16} className="text-white" data-id="element-450" />;
      default:
        return null;
    }
  };
  const getColor = (status: TimelineStep['status']) => {
    switch (status) {
      case 'completed':
        return 'bg-light-green';
      case 'active':
        return 'bg-dark-green';
      case 'error':
        return 'bg-red-500';
      default:
        return 'bg-sand';
    }
  };
  return <div className="space-y-4" data-id="element-451">
      {steps.map((step, index) => <div key={index} className="flex gap-3" data-id="element-452">
          <div className="flex flex-col items-center" data-id="element-453">
            <div className={`w-8 h-8 rounded-full ${getColor(step.status)} flex items-center justify-center`} data-id="element-454">
              {getIcon(step.status)}
            </div>
            {index < steps.length - 1 && <div className={`w-0.5 h-8 ${step.status === 'completed' ? 'bg-light-green' : 'bg-sand'}`} data-id="element-455" />}
          </div>
          <div className="flex-1 pb-4" data-id="element-456">
            <p className={`font-medium ${step.status === 'pending' ? 'text-moss-gray' : 'text-charcoal'}`} data-id="element-457">
              {step.label}
            </p>
            {step.timestamp && <p className="text-sm text-moss-gray mt-1" data-id="element-458">{step.timestamp}</p>}
          </div>
        </div>)}
    </div>;
}